var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "ind"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("ind", Object.prototype.hasOwnProperty.call(kwargs, "ind") ? kwargs["ind"] : 1);var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormUploadPoster\">\n\n        <div class=\"SubmissionFormUploadPoster-order\">";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ind"), env.opts.autoescape);
t_5 += "</div>\n        <div class=\"SubmissionFormUploadPoster-description TextFormatting\">\n            <h3>Upload Title Card</h3>\n            <p>• Shown on the ADG website to represent your project</p>\n            <p>• The minimum size is 1920 pixels wide by 1080 pixels high</p>\n            <p>• Format your image as either JPG, PNG, or GIF</p>\n        </div>\n\n        <div class=\"SubmissionFormUploadPoster-cover\" data-state=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsCover")) {
t_5 += "loaded";
;
}
else {
t_5 += "empty";
;
}
t_5 += "\">\n            <input class=\"SubmissionFormUploadPoster-input\" type=\"file\" id=\"assetsCover\" name=\"assetsCover\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsCover")) {
t_5 += "data-file=\"";
t_5 += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsCover")), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n\n            <img class=\"SubmissionFormUploadPoster-image\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsCover")) {
t_5 += "src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsCover")),"w680_url"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " alt=\"\">\n\n            <label class=\"SubmissionFormUploadPoster-upload\" for=\"assetsCover\">Upload Image</label>\n\n            <label class=\"SubmissionFormUploadPoster-edit\" for=\"assetsCover\">\n                ";
t_5 += runtime.suppressValue((lineno = 21, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["avatar-edit","0 0 12 18",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n            </label>\n\n            <label class=\"SubmissionFormUploadPoster-delete\">\n                ";
t_5 += runtime.suppressValue((lineno = 25, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["avatar-delete","0 0 16 16",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
t_5 += "\n            </label>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormUploadPoster");
context.setVariable("SubmissionFormUploadPoster", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja
// module id = 64
// module chunks = 0